import { Component,
    Input,
    ElementRef,
    Renderer,
    OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { TreeComponent, TreeService, TreeNode } from '../../../../../../common/tree';
import { InventoryService } from '../inventory.service';
import { Subscription } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { VcTreeConstants } from './vc-tree-constants';
import  inventoryRouteMapper  from '../inventory-route-mapper';
import { DataPasserService } from '../../manage/shared/data-passer.service';
import { DataPasser } from '../../manage/shared/data-passer';
import { RefreshSharedService } from '../../../../../refresh-shared-service';

@Component({
    selector: 'tree-holder',
    providers: [ InventoryService, TreeService ],
    styles: [
        require('./tree-holder.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./tree-holder.html')
})

export default class InventoryTreeHolder implements OnChanges {
    @Input() state: any;
    @Input() set url(url: String) {};
    @Input() set linksMap(linksMap: any) {};
    @Input() set actionsMap(actionsMap: any) {};

    private childrenUrl: String = "/hybridity/api/vc/query?";
    private selected: DataPasser = { entity_id: '', type: '', name: '', vcenter_instanceId: '', vcHost: ''};

    private selectedSearchType: any = '1';
    private nodes = [];
    private originalNodes = [];
    private subscription: Subscription;
    private refreshSubscription: Subscription;
    private menuActionMapping = {};
    private menuLinksMapping = {};
    private vcUuidToNameMap = [];
    private refresh: Subscription;
    private nodeToBeSelectedOnLoad: any;
    private rsService: RefreshSharedService;


    options = {
        idField: 'entity_id',
        displayField: 'name',
        getChildren: this.getChildren.bind(this),
        getIconClass: this.getIconClass.bind(this),
        isExpandedField: 'expanded',
        hasContextMenu: false,
        contextMenuActionMapping: this.menuActionMapping,
        menuLinksMapping: this.menuLinksMapping,
        typeField: 'entityType',
        leafTypes: ['vm', 'host']
    };

    @ViewChild(TreeComponent)
    private tree: TreeComponent;

    constructor(public inventoryTree: InventoryService,
                private elementRef: ElementRef,
                private renderer: Renderer,
                private treeService: TreeService,
                private router: Router,
                private route: ActivatedRoute,
                public passer: DataPasserService,
                private rss: RefreshSharedService) {

                this.rsService = rss;
    }

    ngOnInit() {
        this.subscription = this.rsService.getRefreshParam()
        .subscribe (
          item => {
                this.handleEmittedValues(item);
          });
    }

    handleEmittedValues(item) {
        if (item.shouldReloadInventoryTree) {
            this.treeRefresh(this.tree);
        }
    }

    getElementReference() {
        return this.elementRef;
    }

    ngOnChanges(changes) {
        if (changes && changes.url && changes.url.currentValue) {
            this.subscription =
            this.inventoryTree.getTreeNodes(changes.url.currentValue).subscribe((nodes: any) => {
                    this.nodes = nodes;
                    this.originalNodes = nodes;
                    this.setVcDetails(nodes, this);
                },
                error => { console.log('Error on loading tree'); },
                () => {
                    setTimeout(() => {
                        if (this.nodeToBeSelectedOnLoad) {
                            let nodeToBeSelected = this.tree.treeService.getNodeById(this.nodeToBeSelectedOnLoad);
                            if( nodeToBeSelected ) {
                                nodeToBeSelected.focus();
                            } else {
                                this.tree.treeService.selectFirstRoot();
                            }
                        } else {
                            this.tree.treeService.selectFirstRoot();
                        }
                    });
                }
            );
        }
        if( changes && changes.actionsMap && changes.actionsMap.currentValue ) {
            this.menuActionMapping = changes.actionsMap.currentValue;
        }
        if( changes && changes.linksMap && changes.linksMap.currentValue ) {
            this.menuLinksMapping = changes.linksMap.currentValue;
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.refresh ) {
            this.refresh.unsubscribe();
        }

        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }

    }

    setVcDetails(nodes, this2) {
        for (let node of nodes ) {
            if (node && node.entity_id && node.name) {
                this2.vcUuidToNameMap[node.entity_id] = node.name;
            }
        }
    }

    getChildren(node) {
        let vcId: String = node.data.vcenter_instanceId;
        let parentId: String = ( node.data.entityType === 'vcenter') ? 'group-d1' : node.data.entity_id;
        let entityType: String = node.data.entityType;
        return this.inventoryTree.getChildNodes(this.getChildrenUrl(parentId, vcId, entityType));
    }

    getChildrenUrl(parentId, vcId, entityType) {
        return this.childrenUrl + VcTreeConstants.getChildrenQueryParameters(entityType)
                    + '&filter=parentId==' + parentId + ';vcenterId==' + vcId + '&applyDeploymentContainerFilter=true'; 
    }

    getIconClass(node) {
    }

    onNodeSelection = ($event) => {
        let type = $event.node && $event.node && $event.node.data && $event.node.data.entityType ? $event.node.data.entityType : '',
            routePath = inventoryRouteMapper[type],
            id = $event.node && $event.node && $event.node.data && $event.node.data.entity_id ? $event.node.data.entity_id : '';
        let name = $event.node && $event.node.data && $event.node.data.name ? $event.node.data.name : '';
        let vcenter_instanceId = $event.node && $event.node.data && $event.node.data.vcenter_instanceId ? $event.node.data.vcenter_instanceId : '';
        let vcHost = this.vcUuidToNameMap && vcenter_instanceId ? this.vcUuidToNameMap[vcenter_instanceId] : '';
        this.selected = { entity_id: id , type: routePath, name: name, vcenter_instanceId: vcenter_instanceId, vcHost: vcHost};
        this.passer.setData(this.selected);
    };

    onEvent = ($event) => {
    };

    onTreeInit = ($event) => {
        console.log('Tree Initialised');
    };

    onFocus = ($event) => {
    };

    treeFilter(tree, value) {
        tree.treeService.filterNodes(value, true);
    }

    treeRefresh(tree) {
        tree.treeService.prepareRefresh();
        this.refresh = this.inventoryTree.getTreeNodes('/hybridity/api/vc/query?entityType=vcenter')
            .subscribe((nodes: any) => {
                    this.nodes = nodes;
                    this.originalNodes = nodes;
                    this.setVcDetails(nodes, this);
                },
                error => { console.log('Error on loading tree'); },
                () => { tree.treeService.afterFirstLevelLoad(); }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-tree/tree-holder/tree-holder.component.ts